import Header from "../components/adminHeader.jsx";
import AdminSidebar from "../components/adminSidebar.jsx";
import AdminOperator from "../components/adminOperator.jsx";
import Footer from "../components/footer.jsx";

function AdminOperatorPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <AdminSidebar /> 
      < AdminOperator/> 
    </div>
    <Footer /> 
  </div>

  );
}
export default AdminOperatorPage;
